<template>
    <div class="input-wrapper">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
        >
            <!-- eslint-disable -->
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.11104 0.264893C2.92012 0.264893 0.333374 2.85164 0.333374 6.04256C0.333374 9.23348 2.92012 11.8202 6.11104 11.8202C7.46629 11.8202 8.71255 11.3536 9.69794 10.5723L12.0843 12.9586L13.0271 12.0158L10.6407 9.62946C11.4221 8.64407 11.8887 7.39781 11.8887 6.04256C11.8887 2.85164 9.30196 0.264893 6.11104 0.264893ZM6.11104 1.59823C8.56558 1.59823 10.5554 3.58802 10.5554 6.04256C10.5554 8.4971 8.56558 10.4869 6.11104 10.4869C3.6565 10.4869 1.66671 8.4971 1.66671 6.04256C1.66671 3.58802 3.6565 1.59823 6.11104 1.59823Z"
                    fill="#666666"
                />
            </svg>
            <input
                class="spc-form-input s-input"
                type="text"
                v-model="searchValue"
                :placeholder="placeholder"
                @input="onInput"
            />
            <svg
                v-show="searchValue"
                @click="clearInput"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
            >
                <!-- eslint-disable -->
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM10.4749 4.11089L11.8892 5.5252L9.414 8L11.8891 10.4749L10.4749 11.8891L8 9.414L5.5252 11.8892L4.11089 10.4749L6.586 7.999L4.11083 5.52521L5.52521 4.11083L8 6.586L10.4749 4.11089Z"
                    fill="var(--service-button, #000)"
                    fill-opacity="0.2"
                />
            </svg>
        </div>
</template>
<script>
import { debounce } from 'lodash';
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            searchValue: '',
        };
    },
    methods: {
        onInput: debounce(async function () {
            this.$emit('input', this.searchValue.trim());
        }, 500),
        clearInput() {
            this.searchValue = '';
            this.$emit('input', '');
        },
    },
};
</script>
<style lang="less" scoped>
.input-wrapper {
    padding: 10px 12px;
    margin: 12px 19px;
    height: 20px;
    min-height: 20px;
    max-height: 20px;
    border-radius: 20px;
    // background: var(--button-bg, #fff);
    // background: var(--bg-input, #f6f6f6);
    background: var(--bg-evaluate-tag, #f6f6f6);
    display: flex;
    align-items: center;
    color: var(--font-common,#222);
    .spc-form-input {
    //   color: var(--font-common,#222);
      color: var(--service-button,#000);
      font-size: .14rem;
      &::placeholder {
        color: var(--font-desc, #666);
      }
    }
  .s-input {
    margin-left: 6px;
    line-height: 20px;
    width: 100%;
  }
}
</style>
